import "../../styles/_colors.scss";
import "./sidebar.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import { withContainerContext } from "../container/ContainerContext";

const SidebarView = props => {
  let style = {};
  if (!isNil(props.paddingLeft)) {
    style.paddingLeft = `${props.paddingLeft}px`;
  }
  if (!isNil(props.width)) {
    style.width = `${props.width}px`;
  }
  if (!isNil(props.fontSize)) {
    style.fontSize = props.fontSize;
  }

  return (
    <div className="sidebar" style={style}>
      {props.children}
    </div>
  );
};

SidebarView.propTypes = {
  width: PropTypes.number.isRequired,
  children: PropTypeShapes.elementOrArray,
  fontSize: PropTypes.number,

  // From containerContext
  paddingLeft: PropTypes.number.isRequired
};

export default withContainerContext(SidebarView);
